// GENERATED by scripts/generate_all.py from src/eko/capabilities.py — do not edit.
export const CAPABILITIES = [
  'overview.view',
  'expense.attest',
  'customer_invoice.send',
  'customer_invoice.remind',
  'article.create',
  'eventor.import_invoices',
  'eventor.register_payments',
  'eventor.fix_registrations',
  'swish.book',
  'config.swish_messages',
  'config.swish_categories',
  'config.swish_default',
  'config.budget',
  'member.import',
  'admin.roles',
  'admin.company_config',
  'admin.eventor_persons',
] as const

export type Capability = typeof CAPABILITIES[number]

export type CapabilityKind = 'scoped' | 'company' | 'admin'

export const CAPABILITY_KIND: Record<Capability, CapabilityKind> = {
  'overview.view': 'scoped',
  'expense.attest': 'scoped',
  'customer_invoice.send': 'scoped',
  'customer_invoice.remind': 'scoped',
  'article.create': 'scoped',
  'eventor.import_invoices': 'scoped',
  'eventor.register_payments': 'scoped',
  'eventor.fix_registrations': 'scoped',
  'swish.book': 'scoped',
  'config.swish_messages': 'scoped',
  'config.swish_categories': 'scoped',
  'config.swish_default': 'company',
  'config.budget': 'company',
  'member.import': 'company',
  'admin.roles': 'admin',
  'admin.company_config': 'admin',
  'admin.eventor_persons': 'admin',
}
